import { Button, Tooltip, TooltipContent, TooltipTrigger } from "@pdfking/components"
import { MoonIcon, SunIcon } from "lucide-react"
import type { ComponentProps } from "preact"

import { useTranslationTyped } from "../i18n/useTranslation"
import { Settings } from "../settings/Settings"

// A host's color-scheme switch — the viewer itself knows nothing about dark
// mode, so this reads and writes the host's Settings directly (which
// also owns the `dark` class on the root element). Rendered wherever there's
// room for it: the welcome and processing pages, and the viewer's rail.
//
// `side` follows where it's rendered — below by default (a footer or header
// row, which is most of them), overridden to "right" in the viewer's vertical
// rail where there's nothing underneath.
export function DarkModeSwitch({
  side = "bottom",
}: {
  side?: ComponentProps<typeof TooltipContent>["side"]
}) {
  const pdfview = useTranslationTyped("pdfview")

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex">
          <Button onClick={() => (Settings.dark = !Settings.dark)} size="icon" variant="ghost">
            {Settings.dark ? <SunIcon className="size-4" /> : <MoonIcon className="size-4" />}
          </Button>
        </span>
      </TooltipTrigger>
      <TooltipContent align="center" side={side}>
        {pdfview.CHANGE_DARK_MODE()}
      </TooltipContent>
    </Tooltip>
  )
}
